import React from 'react';
import DemoUSPBadges from './DemoUSPBadges';

const DemoScenarioSelector = ({ scenarios, selectedScenarioId, onScenarioSelect }) => {
  return (
    <div className="demo-scenario-selector demo-scenario-cards">
      {scenarios.map(scenario => (
        <button
          key={scenario.id}
          className={`demo-scenario-card ${
            selectedScenarioId === scenario.id ? 'demo-scenario-card-selected' : ''
          }`}
          onClick={() => onScenarioSelect(scenario.id)}
        >
          <div className="demo-scenario-card-title">{scenario.title}</div>
          <DemoUSPBadges uspTags={scenario.uspTags} size="small" />
        </button>
      ))}
    </div>
  );
};

export default DemoScenarioSelector;
